
interface EventListener {
  event: string,
  callback: any
}

class LoadingOverlayEventBus {
  private static instance: LoadingOverlayEventBus;
  private listeners: EventListener[] = [];

  private constructor() {
  }

  public static getInstance() {
    if (!this.instance) {
      this.instance = new LoadingOverlayEventBus();
    }
    return this.instance;
  }

  public on(event, callback) {
    var listener = {
      event: event,
      callback: callback
    } as EventListener;

    this.listeners.push(listener);
    document.addEventListener(event, (e) => callback(e.detail));
    console.debug(event, ': LoadingOverlay listener added');
  }

  public dispatch(event, data) {
    console.debug(event, ': LoadingOverlay event raised: ');
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  }

  public remove(event) {
    var listener = this.listeners.find((item) => {
      return item.event == event;
    });

    if (listener) {
      document.removeEventListener(listener.event, listener.callback);
      console.debug(event, ': LoadingOverlay listener removed');
    }

    console.debug(event, ': LoadingOverlay listener not found - not removed');
  }
};

export default LoadingOverlayEventBus.getInstance();
